import React from "react";

function Features() {
  const features = [
    {
      title: "Bible Presentation",
      description: "Highlight and present Bible verses seamlessly.",
    },
    {
      title: "Song Management",
      description: "Organize and display song lyrics effectively.",
    },
    {
      title: "Multi-Display Support",
      description: "Present content on multiple screens with ease.",
    },
  ];

  return (
    <section id="features" style={{ padding: "40px 20px", textAlign: "center" }}>
      <h2 style={{ fontSize: "2rem", marginBottom: "20px" }}>Features</h2>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "20px",
          flexWrap: "wrap",
        }}
      >
        {features.map((feature, index) => (
          <div
            key={index}
            style={{
              padding: "20px",
              backgroundColor: "#f8f9fa",
              border: "1px solid #e0e0e0",
              borderRadius: "8px",
              width: "300px",
            }}
          >
            <h3 style={{ fontSize: "1.5rem", marginBottom: "10px" }}>
              {feature.title}
            </h3>
            <p>{feature.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Features;
